import React from "react"
import { FiChevronDown, FiClock } from "react-icons/fi"; 

export const SelectDropdown = ({data, mega}) =>{
    const [open,setOpen] = React.useState(false);
    const [item, setItem] = React.useState(data?.length>0&&data[0]||{});
    
     return true ? ( // data?.length>0? ( // title
      <div className="select">
          <div className="flex select-button" onClick={()=>setOpen(!open)}>
            <p>{item?.name}</p>
            <FiChevronDown />
          </div>
           <div className={`${open?'':'hidden'}`}>
              {!mega && <SelectDropdownFilter setItem={setItem} title={item?.name} setOpen={setOpen} data={data} />}
          </div>
       
        </div>
    ):<></>
  }
  
export const SelectDropdownFilter = ({title, setItem, setOpen, data}) => {
  const itemRef = React.useRef();
  React.useEffect(() => {
    const handleClickOutside = (event) => {
        if (itemRef.current && !itemRef.current.contains(event.target)) {
            // setOpen(!open)
        }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
}, [itemRef]);

  return data?.length>0 ? (
    <div className="select-dropdown" ref={itemRef}>
      <ul>
        {data.map((item,i)=>(
            <li className={`flex ${item.name==title?'active':''}`} onClick={()=>{
              // setOpen(false) setItem(item)
            }}>
              <p>{item.name}</p>
              {item.count && <div className="badge">{item.count}</div>} 
            </li>
        ))}
      </ul>
    </div>
  ):<></>
}
 